import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Higher Order Component which allows amp .
 * @param {*} WrappedComponent - whatever the component we want to render AMP markup. The component must be class based.
 */
const withAmp = (WrappedComponent) => {
  /**
   * Extends the component. Using the render hijacking technique
   */
  class ampedComponent extends WrappedComponent {
    /**
     * Render method
     */
    render() {
      // the amp prop is from the layout component
      const {
        context,
        amp,
        ampEnable,
        ampScripts,
      } = this.props;

      let HelmetTag = Helmet;
      let isAmp = false;

      if (context) {
        const { platform, HelmetComponent } = context;

        if (platform === 'amp') {
          if (ampEnable !== undefined) {
            isAmp = ampEnable;

            if (HelmetComponent) {
              HelmetTag = HelmetComponent;
            }
          } else {
            isAmp = true;
          }
        }
      } else if (amp) {
        isAmp = true;
      }

      // Check if we render AMP and if we have the amp function defined in the parent class
      if (isAmp && (typeof super.amp === 'function')) {
        return (
          <>
            {ampScripts && ampScripts !== undefined && (
              <HelmetTag>
                {Object.keys(ampScripts).map((key, index) => (
                  // eslint-disable-next-line react/no-unknown-property
                  <script async custom-element={key} src={ampScripts[key]} key={index} />
                ))}
              </HelmetTag>
            )}

            {super.amp()}
          </>
        );
      }

      // Just return the render method if nothing is defined
      return super.render();
    }
  }

  /**
   * Valid props
   */
  ampedComponent.propTypes = WrappedComponent.propTypes;

  /**
   * Default props
   */
  ampedComponent.defaultProps = WrappedComponent.defaultProps;

  return ampedComponent;
};
export default withAmp;
